import LabeledSelect from "./LabeledSelect";
import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useEffect} from "react";
import {
  loadFocusedItems,
  setSearchItems,
  tryLoadFocusItems,
  tryLoadInitialSearchData
} from "../../redux/slices/searchSlice";
import {DangerButton} from "../CustomButton";
import {debounce} from "lodash";
import {SEARCH_SELECT_FOCUS_TYPE} from "../../constants/commons";

const FocusedSelect = ({label, value, onChange, emptyMsg, type, extData, ...props}) => {

  const {loading, data, error, init} = useSelector((state) => state.search.focusedItems);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(loadFocusedItems());
  }, [dispatch, data, loading, error]);

  useEffect(() => {
    if (extData && data.length) {
      const selected = data.find((d) => d.id === extData);
      if (onChange) {
        onChange(selected);
      }
    }

  }, [extData, data]);

  const retry = () => {
    dispatch(loadFocusedItems());
  };

  return (

    error ?
      <div className="flex items-center justify-between border-gray-300 border-solid border px-2 rounded">
        <div className="text-error-100 ">{error}</div>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div> :
      <LabeledSelect label={label} value={value} loading={loading}
                     options={data?.filter((item) => item.type === type)}
                     getOptionLabel={(option) => !option.title ? `${option.type}(${option.id})` : option.title}
                     getOptionValue={(option) => option.id}
                     onChange={onChange} emptyMsg={emptyMsg} {...props}/>


  );


};


export default React.memo(FocusedSelect);

export const FocusedSearchSelect = ({label, value, onChange, emptyMsg, type = SEARCH_SELECT_FOCUS_TYPE, extData, isDisabled, isRequired, ...props}) => {

  const error = useSelector((state) => state.search.fItems.error);
  const initialDataLoading = useSelector((state) => state.search.initialData[extData]?.loading) ?? false;
  const dispatch = useDispatch();


  useEffect(() => {
    return () => {
      if (error) {
        dispatch(setSearchItems({element: "fItems", error: ""}));
      }
    };
  }, [type]);


  // noinspection JSCheckFunctionSignatures
  const debouncedFocusedSearch = useCallback(
    debounce((searchText, callback) => {
      dispatch(tryLoadFocusItems({callback, query: searchText.trim(), type}));
    }, 500),
    [type]
  );


  return (
    <>

      {error ?
        <div className="flex items-center justify-between border-gray-300 border-solid border px-2 rounded">
          <div className="text-error-100 ">{error}</div>
          <DangerButton onClick={() => dispatch(setSearchItems({element: "fItems", error: ""}))}>Retry</DangerButton>
        </div> :
        <LabeledSelect label={label} isRequired={isRequired} value={value}
                       isDisabled={isDisabled || initialDataLoading}
                       loading={isDisabled || initialDataLoading}
                       loadOptions={debouncedFocusedSearch}
                       // getOptionLabel={(option) => !option.title ? `${option.type}(${option.id})` : option.title}
                       getOptionLabel={(option) => option.title ?? option.label}
                       getOptionValue={(option) => option.id}
                       onChange={onChange} emptyMsg={emptyMsg} {...props}/>}

      {extData && <InitialDataLoader onChange={onChange} data={extData} type={type}/>}
    </>


  );


};

const InitialDataLoader = React.memo(({data, onChange, type}) => {
  const {init = false, data: _data = {}, loading, error = ""} = useSelector((state) => state.search.initialData[`${data}-${type}`]) ?? {};
  const dispatch = useDispatch();

  //
  useEffect(() => {
    if (Object.keys(_data).length && onChange) {
      onChange(_data);
    }

  }, [_data]);

  useEffect(() => {
    if (!init && !loading && !error) {
      dispatch(tryLoadInitialSearchData({id: data, type}));
    }

  }, [init, loading]);

  return (
    <></>

  );

});



